<template>
	<div class="home">
		<!-- <leftNav class='leftNavManage' :htmlon='htmlon' /> -->
		<div class="logobox">
			<div class="logo">
				<img src="@/assets/logo.png" alt="">
			</div>
		</div>
		<topBar class='topBar' ref='tb' :htmlon='htmlon' />
		<div class="main">
			<div class="appList">
				<div class="li" v-for='(item,index) in list'>
					<div class="img" >
						<img :src="item.head_img || 'https://qz.faisys.com/image/head.png?v=201801221411'" alt="">
					</div>
					<div class="info">
						<div class="text">
							<span>小程序名称： </span>
							<span>{{item.title}} </span>
						</div>
						<div class="btns">
							<el-button size='small' type='primary' @click='routeTo("/blocks/index/0",item.id)'>设计小程序</el-button>
							<el-button size='small' @click='routeTo("/manage/index",item.id)'>管理小程序</el-button>
							<el-button size='small' type='danger' v-if='isAdmin==1 && item.is_template==1' @click='cancle_template(item.id)'>取消模板</el-button>
							<el-button size='small' type='warning' v-if='isAdmin==1 && item.is_template==0' @click='setTemplate(item.id)'>设为模板</el-button>
							<!-- <el-button size='small'>删除小程序</el-button> -->
						</div>
					</div>
					<div class="rightbox">
						<div class="section" @click='get_src(item)' type='text'><svg-icon class='ico' icon-class='src'/> <span>获取链接</span></div>
						<div class="section" @click='get_qrcode(item)' type='text'><svg-icon class='ico' icon-class='qrcode'/> <span>生成二维码</span></div>
						<div class="section" type='text' @click='delApp(item)'><svg-icon class='ico' icon-class='del'/> <span>删除小程序</span></div>
					</div>
				</div>
				<el-dialog title="设为模板" :visible.sync="showSetTemplate" append-to-body width="800px">
					<el-form label-width='100px'>
						<el-form-item label='选择分类'>
							<el-select v-model="forms.cid" placeholder="请选择">
								<el-option v-for="(item,index) in classify" :key="item.id" :label="item.title" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label='缩略图(小图)'>
							<div class="jimg" @click='changeImg("img")'>
								<img :src="forms.img" v-if='forms.img'>
								<svg-icon v-else icon-class='add'></svg-icon>
							</div>
						</el-form-item>
						<el-form-item label='预览图(大图)'>
							<div class="jimg" @click='changeImg("big_img")'>
								<img :src="forms.big_img" v-if="forms.big_img">
								<svg-icon v-else icon-class='add'></svg-icon>
							</div>
						</el-form-item>
						<el-form-item label='关键字'>
							<el-input type='textarea' v-model='forms.keyword' placeholder='多个关键字用“,”隔开' rows='3'></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="showSetTemplate = false">取 消</el-button>
						<el-button type="primary" @click="submitTemplate">确 定</el-button>
					</span>
				</el-dialog>

			</div>

		</div>
	</div>
</template>

<script>
	import leftNav from "./components/leftNav"
	import topBar from "./components/topBar"
	import appMain from "./components/topBar"
	import {getApplist,delApp,get_template_classify,submitTemplate,cancle_template} from "@/api/api"
	import {setWxappid,getWxappid,get_template_admin} from "@/utils/auth"
	let dialogs;
	export default{
		components:{
			leftNav,topBar,appMain
		},
		data(){
			return{
				htmlon:2,
				list:[],
				isAdmin:get_template_admin(),
				showSetTemplate:false,
				forms:{
					id:"",
					cid:"",
					img:"",
					big_img:"",
					keyword:""
				},
				classify:[]
			}
		},
		mounted(){
			this.getList();
			console.log(this.$refs)
			dialogs = this.$root.$children[0].$refs.dialogbox;
		},
		methods:{
			get_src(item){
				setWxappid(item.id);
				console.log(item.id)
				this.$store.commit("get_src","scene=1")
			},
			get_qrcode(item){
				setWxappid(item.id);
				console.log(item.id)
				this.$store.commit("get_qrcode","scene=1")
			},
			submitTemplate(){
				submitTemplate(this.forms,this,res=>{
					this.$message({
						type:'success',
						message:res.data.msg
					})
					this.showSetTemplate=false;
					this.getList()
				})
			},
			cancle_template(id){
				cancle_template({id},this,res=>{
					this.$message({
						type:'success',
						message:res.data.msg
					})
					this.getList()
				})
			},
			changeImg(where){
				dialogs.selectimgSuccess=()=>{
					dialogs.myimg.forEach((val,index)=>{
						if(val.check) 
							if(where == "img"){
								this.forms.img=dialogs.siteUrl+val.url;
							}else{
								this.forms.big_img=dialogs.siteUrl+val.url;
							}
						})
					dialogs.showImgSelect=false;
				}
				dialogs.selectImg()
			},

			setTemplate(id){
				this.forms={
					id :id,
					cid:"",
					img:"",
					big_img:"",
					keyword:""
				};
				this.get_template_classify()
				this.showSetTemplate = true;
			},
			get_template_classify(){
				get_template_classify(this,res=>{
					this.classify = res.data.classify
				})
			},
			delApp(item){
				this.$confirm('警告：您正在删除小程序 '+item.title+'，是否继续?', '提示', {
					confirmButtonText: item.nick_name?'下一步' :"确定",
					cancelButtonText: '取消',
					confirmButtonClass:'errbtn',
					type: 'warning'
				}).then(() => {
					if(item.nick_name){
						this.$confirm('小程序 '+item.title+'已经获取授权，确认删除?', '提示', {
							confirmButtonText: item.nick_name?'下一步' :"确定",
							cancelButtonText: '取消',
							confirmButtonClass:'errbtn',
							type: 'warning'
						}).then(() => {
							this.toDel(item.id)

						}).catch(() => {     
						});
					}
					else{
						this.toDel(item.id)
					}

				}).catch(() => {     
				});
			},
			toDel(id){
				delApp({id:id},this,res=>{
					this.$message({
						type:'success',
						message:res.data.msg
					})
					this.getList()
				})
			},
			getList(){
				getApplist(this,res=>{
					this.list = res.data.list;
					console.log(res.data.list)
				})
			},
			routeTo(path,id){
				setWxappid(id);
				this.$router.push({
					path:path,
					query:{wxappid:id}
				})
			},
		}
	}
</script>

<style lang="scss">
@import "../../styles/colors.scss";
.jimg{
	width: 120px;
	height: 120px;
	overflow: hidden;
	border: 1px dashed #ccc;
	transition: all 0.3s;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
.jimg:hover{
	border: 1px dashed #666;
}
.jimg img{
	width: 100%;
	min-height: 120px;
}
.main{
	width: 100%;
	height: 100%;
	padding-top: $top_height;
	position: fixed;
	top: 0;
	left: 0;
	background: #f8f8f8;
}
.errbtn{
	background: #f56c6c !important; 
}
.appList{
	width: 100%;
	height: 100%;
	overflow: auto;
	padding-bottom: 50px;
	.li{
		margin: 30px auto 0 auto;
		flex:1 0;
		width: 1000px;
		height: 200px;
		box-shadow: 0 3px 6px rgba(150,150,150,0.2);
		margin-top: 30px;
		background: #fff;
		border-radius: 3px;
		display: flex;
		align-items: center;
		padding: 30px 60px;
		.img{
			width: 130px;
			height: 130px;
			border: 1px solid #eee;
			border-radius: 50%;
			overflow: hidden;
			img{
				width: 130px;
				min-height: 130px;
			}
		}
		.rightbox{
			border-left: 1px dashed #ddd;
			width: 200px;
			height: 100px;
			font-size: 13px;
			color: #333;
			padding-left: 24px;
			margin: 35px 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			.section{
				line-height: 30px;
				cursor: pointer;
			}
			.ico{
				color: #999;
				margin-right: 4px;
			}
		}
		.info{
			display: flex;
			flex-direction: column;
			width: 520px;
			height: 100%;
			justify-content: center;
			margin-left: 30px;
			.text{
				span:first-of-type{
					color: #aaa;
				}
			}
			.btns{
				margin-top: 20px;
			}
		}
	}
}
.logobox{
	width: $left_manage_width;
	background: #273239;
	height: $top_height;
	position: relative;
	z-index: 10;
}
.home .leftNav{
	height: 100%;
	width: $left_manage_width;
	background: #273239;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 3;
}
.home .leftNavManage{
	height: 100%;
	width: $left_manage_width;
	background: #273239;
	position: absolute;
	left: 0;
	top: 0;
	overflow: auto;
	z-index: 3;
}
.home .logo{
	width: 100%;
	height: $top_height;
	background: #2e3c45;
	color: #fff;
	overflow: hidden;
	display: flex;
	justify-content: center;
	cursor: pointer;
}
.home .logo:hover{
	opacity: 0.8;
}
.home .logo img{
	height: 100%;
}
.home .topBar{
	width: calc(100% - 190px);
	margin-left: $left_manage_width;
	height: $top_height;
	position: absolute;
	top: 0;
	left: 0;
	box-shadow: 0 1px 4px 0 rgba(0,0,0,0.15);
	z-index: 12;
	background: #fff;
}
.home .appMain{
	z-index: 1;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background: rgb(240, 240, 240);
	padding-top: $top_height;
	padding-left: $left_manage_width;
}
</style>



// WEBPACK FOOTER //
// src/views/laout/laoutIndex.vue